import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { FiLayers } from 'react-icons/fi';
import { FaBroom } from 'react-icons/fa';

const ToolsPage: React.FC = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const base = `/workspaces/${workspaceId}/workspace/tools`;

  const tools = [
    {
      path: `${base}/consolidation`,
      icon: FiLayers,
      label: 'Consolidation',
      description: 'Find and merge duplicate items, resolve orphaned references.',
      color: 'text-cm-accent-purple',
    },
    {
      path: `${base}/tidy`,
      icon: FaBroom,
      label: 'Tidy',
      description: 'Clean up your workspace — remove stale items and fix inconsistencies.',
      color: 'text-cm-accent-teal',
    },
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-mono font-semibold text-cm-text-primary">Tools</h1>
        <p className="mt-1 text-sm text-cm-text-secondary">
          Analysis and maintenance utilities for your workspace.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tools.map(({ path, icon: Icon, label, description, color }) => (
          <Link
            key={path}
            to={path}
            className="rounded-xl border border-cm-border-subtle bg-cm-bg-surface p-5 hover:border-cm-accent-orange transition-colors group"
          >
            <Icon className={`w-6 h-6 ${color} mb-3`} />
            <h3 className="font-mono font-medium text-cm-text-primary group-hover:text-cm-accent-orange transition-colors">{label}</h3>
            <p className="text-sm text-cm-text-muted mt-1">{description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ToolsPage;
